import { RouterLink } from '@shared/ui'
import { useTranslation } from 'react-i18next'
import { Video, User, Renew, Email } from '@carbon/icons-react'
import { useNavigate } from 'react-router-dom'
import { APPOINTMENT_MODALITY } from '@shared/data-access'
import { observer } from 'mobx-react-lite'
import { useModalContext } from '../../../provider'
import { useRouteState } from '@shared/utils'
import { AppointmentInfoState } from './state'
import { useState } from 'react'
import { ConfirmResendCommunicationsModal } from './components'
import { Button } from '@shared/storybook'

export const AppointmentInfo = observer(
  ({
    canGenerateRoom,
    profileUrl,
    isCoordinator,
    isOwner,
    isEditing,
    showResendComms,
  }) => {
    const { t } = useTranslation()
    const navigate = useNavigate()

    const { onGenerateRoom, meetingUrl, modality, eventId } = useModalContext()
    const [confirmModal, setConfirmModal] = useState(null)
    const { resendCommunications } = useRouteState(AppointmentInfoState, {
      eventId,
    })

    const canView = !isCoordinator || isOwner
    const showVideoCall =
      meetingUrl && canView && modality === APPOINTMENT_MODALITY.online

    const goToProfile = () => {
      navigate(profileUrl)
    }

    const onCloseModal = () => {
      setConfirmModal(null)
    }

    const onResendEmail = () => {
      setConfirmModal(
        <ConfirmResendCommunicationsModal
          onClose={onCloseModal}
          action={resendCommunications}
        />,
      )
    }

    return (
      <>
        {showVideoCall && (
          <RouterLink external to={meetingUrl} target="_blank">
            <Button
              fullWidth={true}
              size="lg"
              startIcon={<Video size={16} />}
              className="!justify-start"
              disabled={isEditing}
            >
              {t('agenda.formModal.meetingUrl')}
            </Button>
          </RouterLink>
        )}
        <Button
          fullWidth={true}
          onClick={goToProfile}
          size="lg"
          startIcon={<User size={16} />}
          className="!justify-start"
          disabled={isEditing}
        >
          {t('agenda.formModal.profileUrl')}
        </Button>
        {showResendComms && (
          <Button
            fullWidth={true}
            variant="secondary"
            onClick={onResendEmail}
            size="lg"
            startIcon={<Email size={16} />}
            className="!justify-start"
            disabled={isEditing}
          >
            {t('agenda.formModal.resendEmail')}
          </Button>
        )}
        {canGenerateRoom && (
          <Button
            fullWidth={true}
            variant="secondary"
            onClick={onGenerateRoom}
            size="lg"
            startIcon={<Renew size={16} />}
            className="!justify-start"
            disabled={isEditing}
          >
            {t('agenda.formModal.generateRoom')}
          </Button>
        )}
        {confirmModal}
      </>
    )
  },
)
